import { render, staticRenderFns } from "./Movimentacoes.vue?vue&type=template&id=000cb905&scoped=true&"
import script from "./Movimentacoes.vue?vue&type=script&lang=js&"
export * from "./Movimentacoes.vue?vue&type=script&lang=js&"
import style0 from "./Movimentacoes.vue?vue&type=style&index=0&id=000cb905&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000cb905",
  null
  
)

export default component.exports